<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter"><em class="i"><strong class="b">“Are you saying you’d marry if you met the right man?”</strong></em></div>
<div class="p"><span>Maddie laughed. “Now don’t go putting words into my mouth, Miles. I’m not a marrying kind of girl.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“So what kind of girl are you?”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“I love the way Miranda Lee confronts today’s relationships with riveting honesty. Her books sizzle with pace and sensuality—always an exciting and compelling read.”</span></div>
<div class="p-d"><span>—Emma Darcy</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459268975_fm01.vue?29786f9a